$('body').on('click keypress', '.showHideAjax', function () {
  ht.showHideAjax($(this));
});
